import DataBinder from "../DataBinder.js";
import SwapPage from "../SwapPage.js";
import Ping from "../Ping.js";
export default class FindServer {

  constructor(app) {
    this.app = app;
    this.pageId = "FindServer";
    this.gamification = app.gamification;
    const config = app.config;
    this.gameServers = config.GameServers || [];
    this.maxPingAllowed = config.maxPingAllowed;
  }
  async show(path, model) {
    const pageId = this.pageId;
    const app = this.app;
    const config = app.config;
    const userdata = app.userdata;

    const swapPage = new SwapPage();
    swapPage.swapPage("FindServer");
    this.populate({ state: "", fastestServer: "", errorMessage: "" });

    let isLoggedIn = userdata?.id;
    if (!isLoggedIn) {
      if (config.autoLogin) {
        await app.autoLogin();
      } else {
        app.navigate("Login");
        return;
      }
    }

    this.findServer();
  }
  populate(model) {
    const pageId = this.pageId;
    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);
  }

  findServer() {

    this.populate({ state: "Searching", fastestServer: "", errorMessage: "" });

    const userdata = this.app.userdata;
    const gameServerPreferred = userdata.gameServerPreferred;
    const maxPingAllowed = this.maxPingAllowed;
    const gameServersConfig = this.gameServers;
    if (gameServerPreferred) {
      this.findFastestServer([gameServerPreferred], maxPingAllowed);
      return;
    }

    this.gamification.GetGameServers(3).then((data) => {
      var urls = [];
      //get urls
      for (var i = 0; i < data.length; i++) {
        urls.push(data[i].Url);
      }
      this.findFastestServer(urls, maxPingAllowed); //user servers online
    }).catch(function (reason) {

      this.findFastestServer(gameServersConfig, maxPingAllowed); //user servers in config
    });
  }
  findFastestServer(gameServers, maxPingAllowed) {
    if (!maxPingAllowed) maxPingAllowed = 1000;
    var urls = gameServers;

    var ping = new Ping();
    ping.findFastestServer(urls, 5)
      .then((fastestServer) => {
        let state = "";
        let loadingStats = "";
        if (fastestServer.ms > maxPingAllowed) {
          state = "HighPing";
          loadingStats = "Your connect is too slow.  Try again later or use wifi.";
        }
        if (fastestServer.ms < maxPingAllowed) {
          state = "Found";

          //save server settting
          this.app.userdata.gameServer = fastestServer.url;
          //todo: save data
          //settings.save();

          //goto online menu
          let href = `#/OnlineMenu`;
          window.location.href = href;
        }

        this.populate({ state: state, fastestServer: fastestServer, errorMessage: "" });
      })
      .catch((reason) => {
        this.populate({ state: "Error", fastestServer: "", errorMessage: reason });
      });
  }



}